// extracted by mini-css-extract-plugin
module.exports = {"PercentageBar":"PercentageBar_PercentageBar__16XG_","Percentage":"PercentageBar_Percentage__15kTQ"};